import { RsvpStatus } from '../types';

export const agendaEndpoints = {
  getEvents: '/api/users/me/schedule',
  createPersonalEvents: '/api/users/me/personalevents',
  updatePersonalEvent: (eventId: string) => `/api/users/me/personalevents/${eventId}`,
  deletePersonalEvent: (eventId: string) => `/api/users/me/personalevents/${eventId}`,
  acceptOrDeclineEventInvitation: (eventId: string, type: RsvpStatus, comments: string) =>
    `/api/users/me/personalevents/${eventId}/rsvp?type=${type}&comments=${encodeURIComponent(comments)}`,
};
